import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { ALL_DAY, SPA_INFO_EDIT, DAYS, SPA_INFO_TAB_LIST } from '../../../../../constants/SpaConst';
import {
  RBAC_PERMISSION_LEVEL_FULL_ACCESS,
  RBAC_TYPE_HOTEL_SPA,
} from '../../../../../constants/RoleConsts';
import CustomDocumentViewer from '../../../../../shared/custom-document-viewer/Custom-Document-Viewer';
import MediaViewer from '../../../../../shared/media-viewer/MediaViewer';
import DetailViewLayout from '../../../../../shared/detail-view-layout/Detail-View-Layout';
import { allSpaInfoSelector } from '../../../../property/propertySlice';
import moment from 'moment';
import LocationViewTab from '../../../../../shared/location-view-tab/Location-View-Tab';
import { parseObj } from '../../../../../utils/commonUtils';
import CustomPhoneNoView from '../../../../../shared/custom-PhoneNoView/CustomPhoneNoView';
import RedirectUrlLink from '../../../../../shared/redirect-url-link/Redirect-Url-Link';
import { CtaView } from './Cta-View';
import { decodeMediaKeyValue } from '../../../../../utils/mediaUtils';

const SpaInfoView = (props) => {
  const { spaInfo, onViewToggle, hotelId, toggleDrawer, permissions } = props;
  const [tabValue, setTabValue] = useState(0);
  const [selectedSpaInfo, setSelectedSpaInfo] = useState(null);
  const [selectedDays, setSelectedDays] = useState([]);
  const [spaDetails, setSpaDetails] = useState([]);
  const [cta, setCtaDetails] = useState([]);

  const originalSpaInfo = useSelector(allSpaInfoSelector);

  useEffect(() => {
    let spaInfoObj = {
      ...originalSpaInfo.find((tempSpaInfo) => tempSpaInfo.id === spaInfo.id),
    };
    setSelectedSpaInfo(spaInfoObj);
    const daysToMap = formatArrayForDisplay(spaInfoObj?.hours?.timings || []);
    setSelectedDays(daysToMap);
  }, [hotelId, originalSpaInfo, spaInfo.id]);

  useEffect(() => {
    if (selectedSpaInfo) {
      const details = [
        {
          id: 1,
          value1: selectedSpaInfo.name,
          value2: selectedSpaInfo.code,
          name1: 'Spa Name',
          name2: 'Spa Code',
        },
        {
          id: 2,
          value1: selectedSpaInfo?.treatmentsMenu?.name || '---',
          value2: selectedSpaInfo?.treatmentsMenu?.type || '---',
          name1: 'Treatments',
          name2: 'Treatments Type',
        },
        {
          id: 3,
          value1: selectedSpaInfo.description,
          name1: 'Description',
          type: 'full',
        },
      ];
      setSpaDetails(details);
    }
  }, [selectedSpaInfo]);

  useEffect(() => {
    if (selectedSpaInfo && selectedSpaInfo.cta) {
      const details = [
        { id: 1, status: selectedSpaInfo?.cta?.status },
        { id: 2, ctaTitle: selectedSpaInfo?.cta?.ctaTitle },
        { id: 3, redirectOption: selectedSpaInfo?.cta?.redirectOption },
        { id: 4, redirectUrl: selectedSpaInfo?.cta?.redirectUrl },
      ];
      setCtaDetails(details);
    }
  }, [selectedSpaInfo]);

  const onClickEdit = (event) => {
    toggleDrawer(SPA_INFO_EDIT, true, selectedSpaInfo);
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const daysConteniousCheck = (days) => {
    const firstIndex = DAYS.findIndex((day) => day.name.toLowerCase() === days[0].toLowerCase());
    for (let i = 0; i < days.length; i++) {
      if (days[i].toLowerCase() !== DAYS[(i + firstIndex) % 7].name.toLowerCase()) return false;
    }
    return true;
  };

  const renderDays = (days) => {
    if (days.length > 2) {
      const areDaysContenious = daysConteniousCheck(days);
      if (areDaysContenious) {
        const tempdays = [days[0], days[days.length - 1]];
        return tempdays
          .map((tempDay) => tempDay.charAt(0).toUpperCase() + tempDay.slice(1, 3).toLowerCase())
          .join(' to ');
      }
      return days
        .map((day) => day.charAt(0).toUpperCase() + day.slice(1, 3).toLowerCase())
        .join(', ');
    } else {
      return days[0] === 'EVERYDAY'
        ? 'EVERYDAY'
        : days.map((day) => day.charAt(0).toUpperCase() + day.slice(1, 3).toLowerCase()).join(', ');
    }
  };

  const renderScreen = () => {
    let { url, type, name } = parseObj(selectedSpaInfo?.treatmentsMenu);

    return (
      <div className='mx-4'>
        {tabValue === 0 && (
          <>
            <div className='row mt-4 mb-2'>
              <div className='col-md-6'>
                <div className='details-label'>Spa Name</div>
                <div className='details-value preview-breaks'>{selectedSpaInfo.name}</div>
              </div>
              <div className='col-md-6'>
                <div className='details-label'>Spa Code</div>
                <div className='details-value'>{selectedSpaInfo.code}</div>
              </div>
            </div>
            <div className='row mt-4 mb-2'>
              <div className='col-md-12'>
                <div className='details-label'>Description</div>
                <div className='details-value preview-breaks'>{selectedSpaInfo.description}</div>
              </div>
            </div>
            <div className='row mt-4 mb-2'>
              <div className='col-md-4'>
                <div className='details-label'>Treatments</div>
                {url && type ? (
                  <CustomDocumentViewer
                    document={{
                      url: url,
                      type: type,
                    }}
                    title={type === 'S3' ? (name ? name : 'Treatments.pdf') : 'Treatments url'}
                  />
                ) : (
                  <span>---</span>
                )}
              </div>
            </div>
            <div className='row mt-4'>
              {selectedSpaInfo.customAttributes &&
                selectedSpaInfo.customAttributes.length > 0 &&
                selectedSpaInfo.customAttributes.map((item, index) => (
                  <div key={index} className='col-md-6 mb-2'>
                    <div className='details-label'>{item.key}</div>
                    <div className='details-value'>{item.value}</div>
                  </div>
                ))}
            </div>
          </>
        )}
        {tabValue === 1 && (
          <>
            {selectedSpaInfo?.hours?.timings?.length === 1 &&
            selectedSpaInfo?.hours?.timings?.[0]?.day === 'EVERYDAY' ? (
              <>
                <div className='row mt-4 mb-2'>
                  <div className='col-md-6'>
                    <div className='details-label'>Available On</div>
                    <div className='details-value'>EveryDay</div>
                  </div>
                </div>
                <div className='row mt-4 mb-2'>
                  <div className='col-md-6'>
                    <div className='details-label'>Hours</div>
                    <div className='details-value'>
                      {selectedSpaInfo?.hours?.timings?.[0]?.from === ALL_DAY
                        ? '24*7'
                        : `${selectedSpaInfo?.hours?.timings?.[0]?.from} - ${selectedSpaInfo?.hours?.timings?.[0]?.to}`}
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <div className='row mt-4 mb-2'>
                {selectedDays.length !== 0 && (
                  <div className='col-md-12'>
                    <div className='details-label'>Open On</div>
                    <div className='details-value'>
                      {selectedDays.map((timing, timeNdx) => (
                        <div className='row' key={timeNdx}>
                          <div className='col-md-12 text'>
                            {renderDays(timing.days)} :{' '}
                            {timing.from === ALL_DAY
                              ? ALL_DAY
                              : `${moment(timing.from, 'HH:mm').format('LT')} - ${moment(
                                  timing.to,
                                  'HH:mm',
                                ).format('LT')}`}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
                {selectedDays.length === 0 && (
                  <div className='col-md-12'>
                    <div className='details-label'>No hours details available</div>
                  </div>
                )}
              </div>
            )}
          </>
        )}
        {tabValue === 2 && (
          <>
            <div className='row mt-4 mb-2'>
              <div className='col-md-6'>
                <div className='details-label'>Email</div>
                <div className='details-value'>
                  {selectedSpaInfo?.contact?.email ? selectedSpaInfo.contact.email : '---'}
                </div>
              </div>
              <div className='col-md-6'>
                <div className='details-label'>Phone Number</div>
                <div className='details-value'>
                  {selectedSpaInfo?.contact?.phone ? (
                    <CustomPhoneNoView value={selectedSpaInfo?.contact?.phone} />
                  ) : (
                    '---'
                  )}
                </div>
              </div>
            </div>
            {selectedSpaInfo?.contact?.information &&
              selectedSpaInfo.contact.information.length > 0 && (
                <div className='row mt-4 mb-2'>
                  <div className='col-md-8'>
                    <div className='details-label'>Information</div>
                    {selectedSpaInfo.contact.information.map((information) => (
                      <div className='details-value'>
                        <div>
                          {information.reviewerTitle} - {information.displayTitle}
                        </div>
                        <div>
                          <RedirectUrlLink url={information.url} />
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
          </>
        )}
        {tabValue === 3 && <LocationViewTab location={selectedSpaInfo?.location} />}
        {tabValue === 4 && <CtaView spaCta={cta} />}
        {tabValue === 5 && (
          <>
            <div className='row pt-4'>
              <MediaViewer 
                images={selectedSpaInfo.images} 
                videos={(() => {
                  const { Video: videoMediaContent } = decodeMediaKeyValue(selectedSpaInfo?.mediaContent);
                  return videoMediaContent || selectedSpaInfo.videos || {};
                })()} 
                gifs={(() => {
                  const { GIF: gifMediaContent } = decodeMediaKeyValue(selectedSpaInfo?.mediaContent);
                  return gifMediaContent || selectedSpaInfo.gifs || {};
                })()}
              />
            </div>
          </>
        )}
      </div>
    );
  };

  return (
    <>
      {selectedSpaInfo && (
        <DetailViewLayout
          onClickEdit={onClickEdit}
          renderScreen={renderScreen}
          handleTabChange={handleTabChange}
          tabValue={tabValue}
          tabList={SPA_INFO_TAB_LIST}
          onViewToggle={onViewToggle}
          title={selectedSpaInfo.name}
          createdUserId={selectedSpaInfo.createdBy}
          isEditable={permissions[RBAC_TYPE_HOTEL_SPA] === RBAC_PERMISSION_LEVEL_FULL_ACCESS}
          tabClass='col-md-7'
          isHeightIncluded={true}
        />
      )}
    </>
  );
};

export default SpaInfoView;

const formatArrayForDisplay = (selectedDays) => {
  const daysToReturn = [];
  let daysList = [...selectedDays];
  while (daysList.length > 0) {
    const firstObject = daysList[0];
    const filteredRows = daysList.filter(
      (dayKey) => dayKey.from === firstObject.from && dayKey.to === firstObject.to,
    );
    daysToReturn.push({
      days: filteredRows.map((filteredRowDaysName) => filteredRowDaysName.day),
      from: filteredRows[0].from,
      to: filteredRows[0].to,
    });

    const tempDaysList = [...daysList];
    filteredRows.forEach((filteredRowsItem) => {
      const findFilteredDayIndex = tempDaysList.findIndex(
        (tempDaysListItem) => tempDaysListItem.day === filteredRowsItem.day,
      );
      tempDaysList.splice(findFilteredDayIndex, 1);
    });
    daysList = [...tempDaysList];
  }
  return daysToReturn;
};
